<template>
    <div class="score-analysis-container">
        <div class="card-container" v-if="Status.LoadingCompleted">
            <!-- 筛选区 -->
            <div class="search-box">
                <el-select v-model="filterForm.province" multiple placeholder="全部省份" style="width: 200px;" clearable>
                    <el-option v-for="item in provinceOptions" :key="item" :label="item" :value="item"></el-option>
                </el-select>
                <el-select v-model="filterForm.kl" multiple placeholder="全部科类" style="width: 200px;" clearable>
                    <el-option v-for="item in klOptions" :key="item" :label="item" :value="item"></el-option>
                </el-select>
                <el-select v-model="filterForm.pc" multiple placeholder="全部批次" style="width: 200px;" clearable>
                    <el-option v-for="item in pcOptions" :key="item" :label="item" :value="item"></el-option>
                </el-select>
                <el-button type="primary" @click="loadData" :loading="loading">查询</el-button>
                <el-button @click="resetFilter">重置</el-button>
            </div>

            <!-- 直方图 -->
            <div class="section-block">
                <div class="chart-wrapper">
                    <div class="chart-controls">
                        <el-radio-group v-model="chartDisplayMode" @change="generateBarChart" size="small">
                            <el-radio-button label="top10">显示前十</el-radio-button>
                            <el-radio-button label="bottom10">显示后十</el-radio-button>
                            <el-radio-button label="all">显示全部</el-radio-button>
                        </el-radio-group>
                    </div>
                    <div class="chart-controls-right">
                        <el-button size="mini" icon="el-icon-download" @click="downloadBar">下载图片</el-button>
                    </div>
                    <v-chart ref="barChart" :option="barOption" style="height: 350px;" autoresize></v-chart>
                </div>
            </div>

            <!-- 详情表格 -->
            <div class="section-block">
                <div class="section-header">
                    <h3 class="section-title">分数详情</h3>
                    <el-button type="success" size="small" icon="el-icon-download" @click="handleExport">导出</el-button>
                </div>
                <div class="data-table-wrapper">
                    <div class="data-table-body">
                        <el-table :data="tableData" border :header-cell-style="{background:'#f5f7fa', color:'#606266', fontWeight: '600'}">
                            <el-table-column type="index" label="序号" min-width="60" align="center"></el-table-column>
                            <el-table-column prop="Province" label="省份" min-width="120" align="center"></el-table-column>
                            <el-table-column prop="Kl" label="科类" min-width="100" align="center"></el-table-column>
                            <el-table-column prop="Pc" label="批次" min-width="150" align="center"></el-table-column>
                            <el-table-column prop="MajorName" label="专业" min-width="250" align="center"></el-table-column>
                            <el-table-column prop="TotalCount" label="录取数" min-width="100" align="center"></el-table-column>
                            <el-table-column prop="MaxScore" label="最高分" min-width="100" align="center">
                                <template slot-scope="scope">
                                    {{ scope.row.MaxScore ? scope.row.MaxScore.toFixed(1) : '-' }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="MinScore" label="最低分" min-width="100" align="center">
                                <template slot-scope="scope">
                                    {{ scope.row.MinScore ? scope.row.MinScore.toFixed(1) : '-' }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="AvgScore" label="平均分" min-width="100" align="center">
                                <template slot-scope="scope">
                                    {{ scope.row.AvgScore ? scope.row.AvgScore.toFixed(1) : '-' }}
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { TYBM_Env } from '../../env.js';
import { TYBM_Tools } from '../../tools.js';
import VChart from 'vue-echarts';
import 'echarts/lib/chart/bar';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/legend';

export default {
    name: 'ScoreAnalysis',
    components: {
        VChart
    },
    inject: ['Loading', 'LoadingCompleted'],
    data() {
        return {
            Status: {
                LoadingCompleted: false
            },
            loading: false,
            filterForm: {
                province: [],
                kl: [],
                pc: []
            },
            provinceOptions: [],
            klOptions: [],
            pcOptions: [],
            tableData: [],
            year: 0,
            chartDisplayMode: 'top10',
            barOption: {}
        };
    },
    methods: {
        loadFilters() {
            const that = this;
            const api_name = '/Analysis/GetScoreFilters';
            const url = TYBM_Env.GetApiUrl(api_name);

            TYBM_Tools.AxiosGetEx(that, api_name, url, { loading: false })
                .then(result => {
                    that.provinceOptions = result.data.ProvinceOptions;
                    that.klOptions = result.data.KlOptions;
                    that.pcOptions = result.data.PcOptions;
                });
        },
        loadData() {
            const that = this;
            that.loading = true;

            const api_name = '/Analysis/GetScoreData';
            let url = TYBM_Env.GetApiUrl(api_name);

            // 添加筛选参数
            const params = [];
            if (that.filterForm.province && that.filterForm.province.length > 0) {
                params.push('Province=' + encodeURIComponent(that.filterForm.province.join(',')));
            }
            if (that.filterForm.kl && that.filterForm.kl.length > 0) {
                params.push('Kl=' + encodeURIComponent(that.filterForm.kl.join(',')));
            }
            if (that.filterForm.pc && that.filterForm.pc.length > 0) {
                params.push('PC=' + encodeURIComponent(that.filterForm.pc.join(',')));
            }
            if (params.length > 0) {
                url += '?' + params.join('&');
            }

            TYBM_Tools.AxiosGetEx(that, api_name, url, { loading_msg: '正在加载数据' })
                .then(result => {
                    that.tableData = result.data.StatList;
                    that.year = result.data.Year;

                    if (that.provinceOptions.length === 0) {
                        that.loadFilters();
                    }

                    that.generateBarChart();
                    that.Status.LoadingCompleted = true;
                })
                .catch(() => {
                    that.$message.error('加载数据失败');
                })
                .finally(() => {
                    that.loading = false;
                });
        },
        resetFilter() {
            this.filterForm.province = [];
            this.filterForm.kl = [];
            this.filterForm.pc = [];
            this.loadData();
        },
        generateBarChart() {
            const that = this;
            
            const sortedData = [...that.tableData].sort((a, b) => (b.AvgScore || 0) - (a.AvgScore || 0));

            let filteredData = [];
            if (that.chartDisplayMode === 'top10') {
                filteredData = sortedData.slice(0, 10);
            } else if (that.chartDisplayMode === 'bottom10') {
                filteredData = sortedData.slice(-10);
            } else {
                filteredData = sortedData;
            }

            const labels = filteredData.map(item => item.MajorName);
            const maxScores = filteredData.map(item => item.MaxScore || 0);
            const minScores = filteredData.map(item => item.MinScore || 0);
            const avgScores = filteredData.map(item => item.AvgScore || 0);

            that.barOption = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {
                    data: ['最高分', '最低分', '平均分']
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '15%',
                    top: '10%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: labels,
                    axisLabel: {
                        interval: 0,
                        rotate: 0,
                        fontSize: 10
                    }
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        name: '最高分',
                        type: 'bar',
                        data: maxScores,
                        barMaxWidth: 20,
                        itemStyle: {
                            color: '#F56C6C'
                        }
                    },
                    {
                        name: '最低分',
                        type: 'bar',
                        data: minScores,
                        barMaxWidth: 20,
                        itemStyle: {
                            color: '#67C23A'
                        }
                    },
                    {
                        name: '平均分',
                        type: 'bar',
                        data: avgScores,
                        barMaxWidth: 20,
                        itemStyle: {
                            color: '#409EFF'
                        }
                    }
                ]
            };
        },
        downloadBar() {
            const chart = this.$refs.barChart;
            if (chart) {
                const url = chart.getDataURL({
                    type: 'png',
                    pixelRatio: 2,
                    backgroundColor: '#fff'
                });
                const link = document.createElement('a');
                link.download = `分数直方图_${this.year}.png`;
                link.href = url;
                link.click();
            }
        },
        handleExport() {
            const that = this;
            if (that.tableData.length === 0) {
                that.$message.warning('没有数据可导出');
                return;
            }

            let csvContent = "\uFEFF";
            const headers = ["序号", "省份", "科类", "批次", "专业", "录取数", "最高分", "最低分", "平均分"];
            csvContent += headers.join(",") + "\n";

            that.tableData.forEach((row, index) => {
                const rowData = [
                    index + 1,
                    row.Province,
                    row.Kl,
                    row.Pc,
                    row.MajorName,
                    row.TotalCount,
                    row.MaxScore ? row.MaxScore.toFixed(1) : '-',
                    row.MinScore ? row.MinScore.toFixed(1) : '-',
                    row.AvgScore ? row.AvgScore.toFixed(1) : '-'
                ];
                csvContent += rowData.join(",") + "\n";
            });

            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", `分数详情_${that.year}.csv`);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    },
    created() {
        this.loadData();
    },
    mounted() {
        this.$root.$on('global-year-change', this.loadData);
    },
    beforeDestroy() {
        this.$root.$off('global-year-change', this.loadData);
    }
};
</script>

<style scoped>
.score-analysis-container {
    width: 100%;
}

.search-box {
    display: flex;
    gap: 12px;
    margin-bottom: 15px;
    align-items: center;
}

.section-block {
    margin-bottom: 0px;
    background: white;
    border-radius: 8px;
    padding: 5px;
}

.section-title {
    margin: 0 0 12px 0;
    color: #303133;
    font-size: 16px;
    font-weight: 600;
}

.section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;
}

.chart-wrapper {
    position: relative;
    margin-top: 40px;
}

.chart-controls {
    position: absolute;
    left: 10px;
    top: -30px;
    z-index: 10;
    display: flex;
    gap: 10px;
    align-items: center;
}

.chart-controls-right {
    position: absolute;
    right: 10px;
    top: -30px;
    z-index: 10;
    display: flex;
    gap: 10px;
    align-items: center;
}

.data-table-wrapper {
    background: white;
    border-radius: 8px;
    overflow-x: auto;
    overflow-y: auto;
    max-height: calc(100vh - 520px);
}

.data-table-wrapper::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

.data-table-wrapper::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 5px;
}

.data-table-wrapper::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 5px;
}

.data-table-wrapper::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

.data-table-body {
    width: max-content;
    min-width: 100%;
}

.data-table-body >>> .el-table {
    font-size: 13px;
}

.data-table-body >>> .el-table th,
.data-table-body >>> .el-table td {
    padding: 8px 0 !important;
}

.data-table-body >>> .el-table th {
    background-color: #f5f7fa !important;
    color: #606266;
    font-weight: 600;
}

.data-table-body >>> .el-table__row:hover {
    background-color: #f5f9ff;
}

.data-table-body >>> .el-table .cell {
    padding: 0 8px;
}
</style>
